import { render, staticRenderFns } from "./SubmissionFormStatements.vue?vue&type=template&id=6a08b3c0&scoped=true&"
import script from "./SubmissionFormStatements.vue?vue&type=script&lang=ts&"
export * from "./SubmissionFormStatements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a08b3c0",
  null
  
)

export default component.exports